import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./Subscription.css";

const Subscriptions = () => {
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const convertDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };
  sessionStorage.removeItem("parentPage");

  useEffect(() => {
    const fetchHealthCheck = async () => {
      try {
        const response = await fetch("/server/subscription/health-check");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data.status) {
          sessionStorage.setItem("Server", data.status);
        }
      } catch (error) {
        console.error("Error fetching health check:", error);
      }
    };

    fetchHealthCheck();
  }, []);

  useEffect(() => {
    const fetchUserSession = async () => {
      try {
        const response = await axios.get("/server/subscription/session");
        setUser(response.data);
        if (response.data) {
          const username = `${response.data.first_name || ""} ${
            response.data.last_name || ""
          }`.trim();
          const useremail_id = response.data.email_id || "";
          const useraddress = response.data.locale || "";
          const user_id = response.data.user_id || "";

          sessionStorage.setItem("userName", username);
          sessionStorage.setItem("userEmail", useremail_id);
          sessionStorage.setItem("user_id", user_id);
        }
      } catch (error) {
        console.error("Error fetching user session:", error);
      }
    };

    fetchUserSession();
  }, []);

  const username = user?.first_name + " " + user?.last_name;
  const useremail_id = user?.email_id;
  const useraddress = user?.locale;
  sessionStorage.removeItem("transactionId");
  sessionStorage.removeItem("subscription_id");

  useEffect(() => {
    if (!useremail_id) return;

    setIsLoading(true);
    axios
      .get(`/server/subscription_history/transactionList/${useremail_id}`)
      .then((response) => {

        const transactionDetails = response.data.data["Transactions details"];
        const lineItems = response.data.data["Line Items"];
        const deals = response.data.data["Deals"] || [];

        const lineItemsMap = lineItems.reduce((acc, item) => {
          Object.keys(item).forEach((transactionId) => {
            acc[transactionId] = item[transactionId] || [];
          });
          return acc;
        }, {});

        const dealsMap = deals.reduce((acc, item) => {
          Object.keys(item).forEach((transactionId) => {
            acc[transactionId] = item[transactionId] || [];
          });
          return acc;
        }, {});

        const subscriptionsData = transactionDetails
          .map((transaction) => {
            const transactionId = transaction.id;
            const lineItemData = lineItemsMap[transactionId] || [];
            const waqfsNames = lineItemData
              .map((item) => item.Waqfs?.name)
              .filter(Boolean)
              .join(", ");

            // DAF_Mode logic
            const dafMode = transaction.DAF_Mode || "";
            const dealData = dealsMap[transactionId] || [];

            let displayTitle = waqfsNames; // default to waqfs names

            if (dafMode) {
              // For DAF_Mode "Adopt" or "Customise", get unique donation types
              const donationTypes = [...new Set(
                dealData
                  .map((deal) => deal.Donation_Type)
                  .filter((type) => type && (type === "Zakat" || type === "Sadaqah"))
              )];

              if (donationTypes.length === 2) {
                displayTitle = "Zakat and Sadaqah";
              } else if (donationTypes.length === 1) {
                displayTitle = donationTypes[0];
              } else {
                displayTitle = dafMode === "Customise" ? "Charities Supported" : "Donations";
              }
            }

            const formattedDate1 = transaction.$currency_symbol;
            const sub_date = convertDate(transaction.Created_Time);
            const title = transaction.Name;
            const totalAmount = transaction.Total_Amount;
            const status = transaction.$state;
            const payment_status =
              transaction.Payment_Status == "Success"
                ? "Paid"
                : transaction.Payment_Status;
            const transactionDate = convertDate(transaction.Transaction_Date);
            const frequency = transaction.IsSubscription
              ? "Monthly"
              : "One-time";

            const nextDonationDate = new Date(transactionDate);
            nextDonationDate.setDate(nextDonationDate.getDate() + 30);

            const formattedNextDonationDate =
              nextDonationDate.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              });
            return {
              date: sub_date,
              title: title,
              // amount: `$${totalAmount.toFixed(2)}`,
              amount: totalAmount != null ? `$${totalAmount.toFixed(2)}` : "",
              status: status.charAt(0).toUpperCase() + status.slice(1),
              transactionId: transactionId,
              waqfsNames: waqfsNames,
              displayTitle: displayTitle,
              transactionDate: transactionDate,
              nextDonationDate: formattedNextDonationDate,
              payment_status: payment_status,
              frequency: frequency,
            };
          })
          .filter(Boolean);

        setSubscriptions(subscriptionsData);
      })
      .catch((error) =>
        console.error("Error fetching subscription data:", error)
      )
      .finally(() => setIsLoading(false));
  }, [useremail_id]);

  const navigateTO = (email_id, transactionId) => {
    navigate(`/donationDetails`, {
      state: { email_id, transactionId },
    });
  };

  return (
    <div className="bg-[#F7F7F7] -m-[23px] p-[30px] pl-[40px] pr-[4px]  w-full min-h-screen flex flex-col max-sm:pr-[5px]">
      {isLoading && (
        <div className="absolute inset-0 fixed flex h-150vh justify-center items-center bg-white bg-opacity-75 z-50">
          <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
        </div>
      )}
      <div className="flex flex-col mb-4">
        <h5 className="font-Jost text-2xl font-medium leading-[36.4px] mb-2">
          Donations
        </h5>
        <p className="font-Jost text-lg font-normal leading-[38.6px] text-[#1A1B1C]">
          List of donations you have made.
        </p>
      </div>

      <div className="flex-1 overflow-y-auto max-h-[calc(100vh-150px)] scrollbar">
        <div className="flex flex-col gap-[18px] max-sm:gap-[20px]">
          {subscriptions.length > 0 ? (
            subscriptions.map((donation) => (
              <div
                key={donation.id}
                className="flex flex-row justify-center items-center max-sm:flex-col cursor-pointer max-sm:justify-start max-sm:items-start max-sm:block"
                onClick={() => navigateTO(useremail_id, donation.transactionId)}
              >
                <div className="bg-white rounded-[8px] border-[1px] border-[#0000001A] h-[121px] w-[100%] p-[40px] pr-[32px] pl-[25px] shadow-none max-sm:w-[100%] max-sm:h-[auto] max-sm:p-[20px]">
                  <div className="flex flex-row gap-[50px] items-center max-sm:flex-col max-sm:gap-[20px]">
                    <div className="flex items-center w-[250px] h-[24px] max-sm:w-[100%] max-sm:items-start">
                      <p className="text-black font-Jost text-[18px] font-normal">
                        {donation.transactionDate}
                      </p>
                    </div>
                    <div className="flex items-center w-[250px] h-[49px] max-sm:w-[100%] max-sm:items-start">
                      <p
                        className="font-Jost text-lg font-medium text-[#0E5C57] cursor-pointer line-clamp-1-5"
                        // onClick={() => navigateTO(useremail_id,donation.transactionId )}
                      >
                        {donation.displayTitle}
                      </p>
                    </div>
                    <div className="flex flex-col items-center w-[300px] h-[48px] text-center max-sm:w-[100%] max-sm:items-start">
                      <p className="text-black font-Jost text-[18px] font-normal">
                        {donation.amount}
                      </p>
                      <p className="text-[18px] text-black-400 font-Jost text-sm">
                        {donation.payment_status}
                      </p>
                    </div>
                    <div className="w-[250px] h-[24px] max-sm:w-[100%]">
                      <p className="text-black-400 text-[18px] font-Jost text-sm">
                        {donation.frequency}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-60">
              No subscriptions found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Subscriptions;
